import { ImpactStyle } from "@capacitor/haptics";
import { CELL_STATE, shakeCell } from "../cell";
import { XLINKS } from "../constants";
import { getGeometryCb } from "../levels";
import { Haptics } from "../plugins";
import "../ripple";
import { playMp3 } from "../sound";
import store from "../store";
import { setColors } from "../style";
import { ADD_X_0, ADD_X_1, ADD_Y_0 } from "./cells";
import { gameState, levelDef } from "./gameState";
import { getNumNonClickable, setWinningCells } from ".";
import { Exploder, explodeWithCanvas } from "../explode";

const dropExploder = new Exploder();

export function dropSeries() {
  explodeWithCanvas(
    dropExploder,
    store.innerWidth / 2,
    store.innerWidth / 2,
    2 * store.animationSpeed
  );
  return new Promise((resolve, reject) => {
    drop(null, reject);
    setTimeout(drop, 500 / store.animationSpeed, null, reject);
    setTimeout(drop, 1000 / store.animationSpeed, resolve, reject);
  });
}

export function drop(resolve, reject) {
  try {
    let occupiedCounter_ = 0;
    let runCounter = 0;
    Math.round(levelDef.fieldSize / 3);
    while (occupiedCounter_ < 3 && runCounter < 999) {
      runCounter += 1;
      const rx = Math.floor(Math.random() * levelDef.fieldSize);
      const ry = Math.floor(Math.random() * levelDef.fieldSize);
      if (!gameState.cats.in(rx, ry)) {
        const cell = gameState.cells[ry][rx];
        if (cell.state == CELL_STATE.FREE) {
          cell.state = CELL_STATE.BLOCKED;
          cell.win = false;
          occupiedCounter_ += 1;
          cell.id.setAttributeNS(XLINKS, "xlink:href", "#blocked-cell");
          shakeCell(cell.id);
        }
      }
    }
    playMp3("collect");
    Haptics.impact({ style: ImpactStyle.Heavy });
  } catch (e) {
    reject(e);
  }
  resolve && resolve();
}

const shuffleExploder = new Exploder();

function _shuffle(resolve, reject) {
  try {
    let numFreed = 0;
    // free up all
    for (let i = 2; i < levelDef.fieldSize - 2; i++) {
      for (let j = 2; j < levelDef.fieldSize - 2; j++) {
        const cell = gameState.cells[i][j];
        if (cell.state == CELL_STATE.BLOCKED) {
          cell.state = CELL_STATE.FREE;

          cell.id.setAttributeNS(XLINKS, "xlink:href", "#free-cell");
          //   cell.id.setAttributeNS(null, "fill", store.themes[1]);
          numFreed += 1;
        }
      }
    }
    // block again
    let runCounter = 0;
    if (!numFreed) return resolve(false);
    explodeWithCanvas(
      shuffleExploder,
      store.innerWidth / 2,
      store.innerWidth / 2,
      2 * store.animationSpeed
    );
    const millis = Math.min(1000 / numFreed, 80);
    for (let i = 0; i < numFreed; i++)
      setTimeout(() => {
        // TODO: make this non-anonymous
        const isLast = i == numFreed - 1;
        try {
          while (runCounter < levelDef.fieldSize ** 2) {
            runCounter += 1;
            const numNonClickable = getNumNonClickable();
            if (numNonClickable == levelDef.innerFieldSize)
              return isLast && resolve();
            const rx = 1 + Math.floor(Math.random() * (levelDef.fieldSize - 2));
            const ry = 1 + Math.floor(Math.random() * (levelDef.fieldSize - 2));
            const cell = gameState.cells[ry][rx];
            if (!gameState.cats.in(rx, ry) && cell.state == CELL_STATE.FREE) {
              cell.state = CELL_STATE.BLOCKED;
              cell.win = false;
              cell.id.setAttributeNS(XLINKS, "xlink:href", "#blocked-cell");
              //   cell.id.setAttributeNS(null, "fill", store.themes[0]);
              shakeCell(cell.id);
              return isLast && setTimeout(resolve, 400);
            }
          }
          isLast && setTimeout(resolve, 400);
        } catch (e) {
          reject(e);
        }
      }, millis * i);
    playMp3("shuffle");
  } catch (e) {
    reject(e);
  }
}

function setWinningCellsAndReturnResult(result) {
  setWinningCells();
  return result;
}

export function shuffle() {
  return new Promise((resolve, reject) => {
    setTimeout(_shuffle, 200, resolve, reject);
    Haptics.impact({ style: ImpactStyle.Heavy });
  }).then(setWinningCellsAndReturnResult);
}

function resetCats(resolve, reject) {
  //   explodeWithCanvas(store.innerWidth / 2, store.innerWidth / 2, 2);
  try {
    gameState.cats.removeShapes();
    gameState.cats.reset(levelDef.catPlacement);
    gameState.cats.appendShapes();
    gameState.cats.displayRandom();
    setColors();
  } catch (e) {
    reject(e);
  }
  resolve();
}

export function center() {
  return new Promise((resolve, reject) => {
    if (store.step == 0) return resolve(false);
    let allCatsInInitPlacement = true;
    for (const cat of gameState.cats.getAll()) {
      const catInInitPlacement = [];
      for (const [shape, shapeVariable] of levelDef.catPlacement.shapes)
        catInInitPlacement.push(
          getGeometryCb(levelDef.fieldSize, shape, shapeVariable)(cat.y, cat.x)
        );
      if (!catInInitPlacement.includes(true)) allCatsInInitPlacement = false;
    }
    if (allCatsInInitPlacement) return resolve(false);
    playMp3("teleport");
    setTimeout(resetCats, 250, resolve, reject);
    for (let i = 0; i < 4; i++) setTimeout(Haptics.impact, 150 * i);
  });
}

export function freezeCat(cat) {
  return new Promise((resolve, reject) => {
    try {
      if (cat.won) return resolve(false);
      cat.freeze();
    } catch (e) {
      reject(e);
    }
    resolve();
  });
}

export function catchCat(cat, excludeList = []) {
  return new Promise((resolve, reject) => {
    playMp3("harp");
    // explodeWithCanvas(store.innerWidth / 2, store.innerWidth / 2, 2);
    for (let i = 0; i < 6; ++i)
      setTimeout(
        _place,
        150 * i,
        cat,
        excludeList,
        i,
        i == 5 && resolve,
        reject
      );
  });
}

export function catchRandomCat() {
    const otherCats = [];
    const cat = gameState.cats.get(
      Math.floor(Math.random() * gameState.cats.num)
    );
    for (const otherCat of gameState.cats.getAll()) {
      if (otherCat.x != cat.x || otherCat.y != cat.y)
        otherCats.push(otherCat.getCoordString());
    }
    return catchCat(cat, otherCats);
  }

export function _place(cat, excludeList, i, resolve, reject) {
  try {
    const x = cat.y % 2 === 0 ? cat.x + ADD_X_0[i] : cat.x + ADD_X_1[i];
    const y = cat.y + ADD_Y_0[i];
    const cell = gameState.cells[y][x];
    if (!cat.isBlocked(y, x, excludeList)) {
      cell.state = CELL_STATE.BLOCKED;
      cell.win = false;
      cell.id.setAttributeNS(XLINKS, "xlink:href", "#blocked-cell");
      Haptics.impact({ style: ImpactStyle.Light });
    }
    shakeCell(cell.id);
    Haptics.impact({ style: ImpactStyle.Light });
  } catch (e) {
    reject(e);
  }
  resolve && setTimeout(resolve, 400);
}
